import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getImage } from '../shops/selectors';
import * as reservationSelectors from '../reservation/selectors';
import config from '../../config';

const mapStateToProps = (state, ownProps) => ({
  backgroundImage:
    ownProps.backgroundImage ||
    getImage(state, ownProps.params.shopRoute) ||
    reservationSelectors.getShopImage(state) ||
    config.fallbackShopBackground,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithShopBackground.js